import { eur } from "@/lib/api";

const PARTS = [
  { k: "transport", l: "Transport", c: "bg-slate-700" },
  { k: "accommodation", l: "Hébergement", c: "bg-amber-600" },
  { k: "food", l: "Repas", c: "bg-emerald-700" },
  { k: "activities", l: "Activités", c: "bg-amber-300" },
];

export const BudgetBar = ({ budget = {}, userBudget, compact = false, testid = "budget-bar" }) => {
  const total = Number(budget.total) || PARTS.reduce((s, p) => s + (Number(budget[p.k]) || 0), 0);
  const within = !userBudget || total <= userBudget;
  return (
    <div data-testid={testid}>
      <div className="flex items-baseline justify-between">
        <span className="font-mono text-[11px] uppercase tracking-widest text-gray-500">Budget estimé</span>
        <span data-testid={`${testid}-total`} className="font-serif text-2xl font-semibold text-[#0B131E]">{eur(total)}</span>
      </div>
      <div className="mt-3 flex h-2 rounded-full overflow-hidden bg-gray-100">
        {PARTS.map((p) => (
          <div key={p.k} className={p.c} style={{ width: `${((Number(budget[p.k]) || 0) / (total || 1)) * 100}%` }} />
        ))}
      </div>
      <div className={`mt-3 grid ${compact ? "grid-cols-2" : "grid-cols-2 sm:grid-cols-4"} gap-x-4 gap-y-1.5 text-xs`}>
        {PARTS.map((p) => (
          <div key={p.k} className="flex items-center justify-between gap-2 text-gray-600">
            <span className="flex items-center gap-1.5"><span className={`w-2 h-2 rounded-full ${p.c}`} />{p.l}</span>
            <span className="font-medium text-gray-800">{eur(budget[p.k])}</span>
          </div>
        ))}
      </div>
      {userBudget ? (
        <p data-testid={`${testid}-status`} className={`mt-3 text-xs font-medium ${within ? "text-emerald-700" : "text-amber-700"}`}>
          {within ? `Dans votre budget — marge de ${eur(userBudget - total)}` : `Dépasse votre budget de ${eur(total - userBudget)}`}
        </p>
      ) : null}
    </div>
  );
};
